require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-join-us-for-a-hands-on-ibeacon-workshop.json") })
        }
      }, "path---blog-join-us-for-a-hands-on-ibeacon-workshop");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-join-us-for-a-hands-on-ibeacon-workshop!./.cache/json/blog-join-us-for-a-hands-on-ibeacon-workshop.json
// module id = 913
// module chunks = 231608221292675